import Button from '@uikit/components/Button/Button';
import { ButtonAlign, ButtonColor } from '@uikit/components/Button/consts';
import { ClickableAction } from '@uikit/components/Clickable/consts';
import Container from '@uikit/components/Container/Container';
import MagazineGrid from '@uikit/components/Magazine/MagazineGrid/MagazineGrid';
import MagazineTeaserArticle from '@uikit/components/Magazine/MagazineTeaserArticle/MagazineTeaserArticle';
import Section from '@uikit/components/Section/Section';
import Spacer from '@uikit/components/Spacer/Spacer';
import { Align } from '@uikit/types';
import React from 'react';
import useShowMore from '../../../hooks/useShowMore/useShowMore';
import MagazineArticlesContext from '../../../contexts/Magazine/MagazineArticles.context';
import type { MagazineGridWrapperProps } from './interfaces';
import styles from './MagazineGridWrapper.module.scss';

const MagazineGridWrapper = ({
  children,
  articles,
  loadItemsPerPage = 3,
  ...props
}: MagazineGridWrapperProps) => {
  const { articles: contextArticles } = React.useContext(
    MagazineArticlesContext
  );

  const currentArticles = React.useMemo(
    () => articles || contextArticles,
    [articles, contextArticles]
  );

  const { canGoNext, next, currentPageItems } = useShowMore(
    currentArticles ?? [],
    {
      itemsPerPage: loadItemsPerPage,
      initialPage: children ? 2 : 3,
    }
  );

  return (
    <Section>
      <Container>
        <div>
          <Spacer defaultSize={0} sm={4} lg={5} />
          <MagazineGrid {...props} align={Align.Left}>
            {children}

            {currentPageItems.map((props) => (
              <MagazineTeaserArticle key={props.id} {...props} />
            ))}
          </MagazineGrid>
        </div>
      </Container>

      {canGoNext && (
        <div className={styles.buttonWrapper}>
          <Spacer defaultSize={2} xs={3} sm={1} />
          <Button
            actionType={ClickableAction.Custom}
            color={ButtonColor.Outline}
            onClick={next}
            align={ButtonAlign.Center}
            className={styles.button}
          >
            Mehr laden
          </Button>
          <Spacer defaultSize={1} />
        </div>
      )}
    </Section>
  );
};

export default MagazineGridWrapper;
